import React, { useContext, useEffect, useState } from 'react';
import { Button, Row } from 'react-bootstrap';
import NumberFormat from 'react-number-format';
import Moment from 'react-moment';

import { faChartBar } from '@fortawesome/free-solid-svg-icons';
import RebateDetails from './RebateDetails';
import OrderContext from '../../OrderContext';
import axios from 'axios';
import AuthContext from '../../../../authentication/AuthContext';
import { useAlert } from 'react-alert';
import { IconWrapper } from '../../../../common/IconWrapper';

export default function RebateSummary({ showRebateDetailsParent }) {
    const alert = useAlert();
    const cas = useContext(AuthContext);
    const { orderId, orderHeader } = useContext(OrderContext);
    const [rebateSummary, setRebateSummary] = useState();
    const [showRebateDetails, setShowRebateDetails] = useState(false);

    useEffect(() => {
        setShowRebateDetails(showRebateDetailsParent);
    }, [showRebateDetailsParent]);

    useEffect(() => {
        axios
            .get(
                window.CONFIG['ws.activoc-web-order-api.order.rebates.progress'].replace(
                    '{orderId}',
                    orderId
                ),
                {
                    headers: {
                        Authorization: cas,
                        'Content-Type': 'application/json'
                    }
                }
            )
            .then(response => {
                setRebateSummary(response.data);
            })
            .catch(() => {
                alert.error('ERROR: Unable to retrieve rebate information.');
            });
        // eslint-disable-next-line
    }, [cas, orderId, orderHeader]);

    return (
        <>
            {rebateSummary && (
                <Row className={'rebate-row flex'}>
                    {rebateSummary.nextRebatePercentage ? (
                        <div>
                            <span>Spend another </span>
                            <strong>
                                <NumberFormat
                                    value={rebateSummary.valueToSpend}
                                    displayType={'text'}
                                    fixedDecimalScale={true}
                                    decimalScale={2}
                                    prefix={'£'}
                                />
                            </strong>
                            <span> to achieve </span>
                            <strong>
                                <NumberFormat
                                    value={rebateSummary.nextRebatePercentage}
                                    displayType={'text'}
                                    fixedDecimalScale={true}
                                    decimalScale={2}
                                />
                                <span>%</span>
                            </strong>
                            <span> rebate by </span>
                            <strong>
                                <Moment format={'DD/MM/YYYY'}>{rebateSummary.periodEndDate}</Moment>
                            </strong>
                        </div>
                    ) : (
                        <div>
                            You've achieved the top rebate level. Keep spending to take advantage of our best
                            prices.
                        </div>
                    )}
                    <Button variant={'secondary'} onClick={() => setShowRebateDetails(!showRebateDetails)}>
                        <IconWrapper icon={faChartBar} />
                        {showRebateDetails ? 'Hide' : 'See'} More
                    </Button>
                </Row>
            )}
            {showRebateDetails && (
                <Row>
                    <RebateDetails />
                </Row>
            )}
        </>
    );
}
